/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import React, { useState } from "react";

/**
 * CustomReportFormatModal component for selecting report format
 * @param {Object} props - Component props
 * @param {Function} props.closePopup - Function to close the modal
 * @param {Function} props.onSimpleReportSelect - Function called when simple report is selected
 * @param {Function} props.onMyopiaReportSelect - Function called when myopia report is selected
 */
const CustomReportFormatModal = ({
  closePopup,
  onSimpleReportSelect,
  onMyopiaReportSelect
}) => {
  const [selectedFormat, setSelectedFormat] = useState("simple");

  const handleProceed = () => {
    if (selectedFormat === "simple") {
      onSimpleReportSelect();
    } else {
      onMyopiaReportSelect();
    }
    closePopup();
  };

  return (
    <div className="custommodal">
      <div className="custommodalinner report-format-modal">
        <div className="firstpage">
          <div className="hrpadding">
            <h4 className="modal-heading">Choose Report Format</h4>
            <button className="cancle" onClick={closePopup}>
              <span className="cross">✕</span>
            </button>
          </div>

          <div className="report-format-content">
            <p className="report-format-description">
              Please choose report format to continue
            </p>

            <div className="report-format-options">
              <div className="report-format-option">
                <div
                  className="report-format-card"
                  onClick={() => setSelectedFormat("simple")}
                >
                  <div className="report-format-preview simple-preview">
                    <div className="preview-lines">
                      <div className="preview-line"></div>
                      <div className="preview-line"></div>
                      <div className="preview-line"></div>
                      <div className="preview-line"></div>
                      <div className="preview-line"></div>
                    </div>
                  </div>
                  <div className="report-format-selection">
                    <input
                      type="radio"
                      id="simple-report"
                      name="reportFormat"
                      value="simple"
                      checked={selectedFormat === "simple"}
                      onChange={e => setSelectedFormat(e.target.value)}
                    />
                    <label
                      htmlFor="simple-report"
                      className="report-format-label"
                    >
                      Simple Report
                    </label>
                  </div>
                </div>
              </div>

              <div className="report-format-option">
                <div
                  className="report-format-card"
                  onClick={() => setSelectedFormat("myopia")}
                >
                  <div className="report-format-preview myopia-preview">
                    <div className="myopia-label">MYOPIC</div>
                    <div className="myopia-chart">
                      <svg width="60" height="40" viewBox="0 0 60 40">
                        <path
                          d="M5,35 Q15,20 25,25 T45,15 L55,10"
                          stroke="#666"
                          strokeWidth="2"
                          fill="none"
                        />
                        <circle cx="15" cy="28" r="2" fill="#666" />
                        <circle cx="35" cy="20" r="2" fill="#666" />
                        <circle cx="50" cy="12" r="2" fill="#666" />
                      </svg>
                    </div>
                  </div>
                  <div className="report-format-selection">
                    <input
                      type="radio"
                      id="myopia-report"
                      name="reportFormat"
                      value="myopia"
                      checked={selectedFormat === "myopia"}
                      onChange={e => setSelectedFormat(e.target.value)}
                    />
                    <label
                      htmlFor="myopia-report"
                      className="report-format-label"
                    >
                      Myopia Report
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="report-format-actions">
              <button className="loginbtn1 proceed-btn" onClick={handleProceed}>
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomReportFormatModal;
